import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pformat1',
  templateUrl: './pformat1.component.html',
  styleUrls: ['./pformat1.component.scss']
})
export class Pformat1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
